<template>
  <!-- <iframe :src="urlLink.url" height="1000" width="100%">
</iframe> -->
  <div id="bettech"></div>
  <!-- <div v-if="urlLink">
    this is teset here
    <div v-html="urlLink" :key="renderGame"></div>
  </div> -->
</template>
<script>
import { mdiThermostatBoxAuto } from "@mdi/js";
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  props: ["selected_tab", "urlLink"],
  data() {
    return {
      renderGame: 0,
      tab: null,
      link: "",
      category: "",
      filteredMatches: [],
      direct_dialog: false,
      componentKey: 0,
    };
  },
  computed: {
    ...mapState("slotegator", ["bt_reader", "session_refresh"]),
    ...mapState("partner", ["partnerlist"]),
  },
  async mounted() {
    this.filteredMatches = this.matches;
    this.onLoad();
    // this.testBTRenderer();
    console.log("FORCE UPDTe");
    this.$forceUpdate();
    this.renderGame = Math.ceil(Math.random() * 100000);
  },
  watch: {
    async selected_tab() {
      this.category = await this.selected_tab;
      if (this.category != "All") {
        this.filteredMatches = await this.matches.filter(
          this.getMatchesByCategory
        );
      } else {
        this.filteredMatches = this.matches;
      }
    },
  },
  methods: {
    ...mapActions("slotegator", ["postAuthGuest", "init"]),
    ...mapActions("partner", ["getPartnerList"]),
    ...mapMutations("slotegator", [
      "SET_BT_READER",
      "SET_SHOW_LOGIN",
      "SET_SHOW_REGISTER",
      "SET_SHOW_DEPOSIT",
      "SET_SHOW_PARTNER_DEPOSIT",
      "SET_SESSION_REFRESH",
    ]),
    getMatchData(item) {
      this.$router.push(`/match/${item.id}`).catch(() => {});
    },
    getMatchesByCategory(category) {
      return category.category_name == this.category;
    },
    async postAuth() {
      console.log("urlLink", this.urlLink);
      await this.postAuthGuest(this.urlLink);
    },
    // async sportsbooksInit() {
    //   const urlLink = await this.init({
    //     currency: process.env.VUE_APP_API_SPORTSBOOK_CURRENCY,
    //     sportsbook_uuid: process.env.VUE_APP_API_SPORTSBOOK_UUID,
    //     email: !!this.user ? this.user.email : "",
    //     player_id: !!this.user ? this.user.id : "",
    //     player_name: !!this.user ? this.user.name : "",
    //     session_id: "",
    //   });
    //   this.urlLink = urlLink.data;
    // },
    closeDirectDialog() {
      this.direct_dialog = false;
    },
    async testBTRenderer() {
      //this.urlLink = `${this.urlLink} <script>alert('tisoy jcm')<\/script>`;
      return this.urlLink;
      // let user = await this.$fetch.get(`${this.urlLink.url}`);
      // console.log("aaaaaaaaaasdadasd", user);
      // user = await user.text();
      // console.log("aaaaaaaaaa", user);
    },
    onLoad: function () {
      let that = this;
      var bt = new BTRenderer().initialize({
        brand_id: this.urlLink.brand_id,
        key: this.urlLink.key,
        //themeName: "demo-orange-darkblue-table",
        themeName: process.env.VUE_APP_BETGAME_THEME,
        lang: "en",
        target: document.getElementById("bettech"),
        minFrameHeight: 700,
        betSlipOffsetTop: 50,
        betslipZIndex: 999,
        // token: this.token,
        // betby configuration options
        onRouteChange: function (route) {
          /*!-template-on-route-change--*/
          // const subString = route.substring(3, route.length);
          // that.$router.push({
          //   path: "/home",
          //   query: {
          //     "bt-path": "/" + subString,
          //   },
          // });
          /*--template-on-route-change-!*/
        },
        onLogin: function () {
          /*!-template-on-login--*/
          that.SET_SHOW_LOGIN(true);
          // that.session_refresh(urlLink)
          /*--template-on-login-!*/
        },
        onRegister: function () {
          /*!-template-on-register--*/
          that.SET_SHOW_REGISTER(true);
          /*--template-on-register-!*/
        },
        onSessionRefresh: function () {
          /*!-template-on-session-refresh--*/
          // this.session_refresh();
          bt.kill();
          that.$router.go(that.$router.currentRoute);
          /*--template-on-session-refresh-!*/
        },
        onRecharge: function () {
          /*!-template-on-recharge--*/
          console.log("that.$auth.user", that.partnerlist);
          let partner = that.partnerlist.success && that.partnerlist.data;
          if (that.$auth.user.registered_partner_id && !!partner.active) {
            that.SET_SHOW_PARTNER_DEPOSIT(true);
          } else {
            that.SET_SHOW_DEPOSIT(true);
          }
          /*--template-on-recharge-!*/
        },
      });
      this.SET_BT_READER(bt);
    },
  },
  async created() {
    this.user = this.$auth.user;
    if (!!this.$auth.user) {
    await this.getPartnerList(this.user);
    }
    console.log("user?", this.user);
  },
};
</script>
<style scoped>
.v-data-table >>> div > table {
  text-indent: 0;
  border-color: inherit;
  border-collapse: unset !important;
  border-spacing: 0px 5px !important;
}
.v-data-table >>> div > table > tbody > tr {
  border-bottom: none !important;
  background-color: rgba(13, 17, 27, 0.75);
}
.v-data-table >>> div > table > tbody > tr > td {
  border-bottom: none !important;
}
.v-data-table >>> div > table > thead > tr > th {
  border: none !important;
}
.v-data-table--mobile >>> div > table > tbody > tr {
  margin-bottom: 10px !important;
}
.v-data-table >>> div > table > tbody > tr > td:nth-child(2) > div > div {
  opacity: 50%;
}
.v-data-table
  >>> div
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background-color: rgba(13, 17, 27, 1) !important;
}
.v-data-table
  >>> div
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper)
  > td:nth-child(2)
  > div
  > div {
  opacity: 100%;
}
</style>